import { useState } from "react";

export default function GeoAnnouncementBar() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div
      className="relative w-full z-[60] flex items-center justify-center cursor-pointer transition-all duration-200 hover:brightness-110"
      style={{
        background: "linear-gradient(90deg, #D97706 0%, #F59E0B 50%, #D97706 100%)",
        minHeight: "44px",
      }}
      onClick={() => { window.location.href = "/ru/"; }}
      role="banner"
      aria-label="Geo routing announcement for Russian and CIS customers"
    >
      {/* Animated left accent */}
      <div
        className="absolute left-0 top-0 bottom-0 w-1"
        style={{ background: "rgba(255,255,255,0.3)" }}
      />

      <div className="flex items-center gap-3 px-10 py-2.5 text-center">
        <span
          className="font-bold text-white leading-snug"
          style={{ fontSize: "clamp(11px, 2vw, 13px)", letterSpacing: "0.02em" }}
        >
          🇷🇺 Для клиентов из России и СНГ: нажмите здесь для перехода на русскую версию сайта ➡️
        </span>
      </div>

      {/* Close button */}
      <button
        className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center rounded-full cursor-pointer transition-all duration-200 hover:bg-white/20"
        onClick={(e) => {
          e.stopPropagation();
          setVisible(false);
        }}
        aria-label="Close announcement"
      >
        <i className="ri-close-line text-white text-sm" />
      </button>
    </div>
  );
}
